/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formatNumber } from 'libphonenumber-js';
import PropTypes, { any } from 'prop-types';
import moment from 'moment-timezone';

import AdWrapper from '../../../../../components/Ads/AdWrapper';
import AddPhoto from '../../../../../components/PhotoUpload/AddPhoto';
import Attachments from './Attachments/Attachments';
import Img from '../../../../../components/Img';
import Linkify from '../../../../../components/text/Linkify';
import Location from '../../../../../components/EventProfile/Location';
import OrganizerCardV2 from '../../../../../components/cards/OrganizerCard/OrganizerCardV2';
import PopOverMenu from '../../../../../components/PopOverMenu';
import SeoURL from './SeoURL';
import WeatherNotifications from '../../../../../components/cards/WeatherNotifications';
import withAuth from '../../../../../components/hocs/withAuth';
import { EventHealthAndSafetyCard } from '../../../../../components/cards';

import { AdTypes } from '../../../../../utils/types';
import { countWords, truncateString } from '../../../../../utils';
import { isEventType, EventTypes } from '../../../../../utils/events';
import { removeBannerPhoto } from '../../../../../actions/event-profile-actions';
import { setOverviewTabState } from '../../../../../actions/event-actions';
import { setPlayerId } from '../../../../../actions/profile-actions';
import { useAdDynamicConfig } from '../../../../../components/hooks/useAdDynamicConfig';
import { PowerFunnelSurfaces } from '../../../../../components/Analytics/constants';
import RecurringEvents from './RecurringEvents';
import StatsigLink from '../../../../../components/Links/StatsigLink';
import { useStatsig } from '../../../../../components/hooks/useStatsig';
import { getNewClubPath } from '../../../../../utils/clubs';

import appConfig from '../../../../../../config';
import styles from '../../../event.scss';

const defaultSponsorLogo = '/img/icons/uploadSponsorLogo.png';

const OverViewTabContentV3 = (props) => {
    const { isCurrentMemberAdmin, showEventPhoneAndEmail = true, bannerImage, collapsed, onEditWeatherNotification } = props;
    const { showAds, eventProfileConfig } = useAdDynamicConfig();
    const showRectangleAd = showAds && eventProfileConfig?.showRectangle;

    const [withdrawalFeeDate, setWithdrawalFeeDate] = useState();
    const auth = useSelector(({ auth }) => auth);
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const profile = useSelector(({ profile }) => profile);
    const { event, overviewTabState, upcomingRecurringEvents } = useSelector(({ eventProfile }) => {
        const { event, overviewTabState, upcomingRecurringEvents } = eventProfile;
        return {
            event,
            overviewTabState,
            upcomingRecurringEvents,
        };
    });
    const dispatch = useDispatch();
    const photoInputRef = useRef(null);
    const { featureGates } = useStatsig();

    const { data: organizerProfileData } = profile;
    const { registrationCancellationPolicy, currency } = event.data || {};

    const showHealthAndSafety = event.data?.healthAndSafetyProtocols?.length > 0 || !!event.data?.additionalSafetyInformation;
    const showCancellationPolicy = !!registrationCancellationPolicy?.withdrawalFee || !!registrationCancellationPolicy?.description;
    const showContactInfo = showEventPhoneAndEmail && (event.data.phone || event.data.email);
    const { isRecurringEvent, eventSchedule } = event.data;
    const showRecurringEvents = isRecurringEvent && upcomingRecurringEvents?.data?.length > 0;

    const openUrl = (url) => {
        if (url) {
            let formattedUrl = url;

            if (!/^https?:\/\//i.test(formattedUrl)) {
                formattedUrl = `https://${formattedUrl}`;
            }
            // Open the formatted URL in a new tab
            window.open(formattedUrl, '_blank');
        }
    };

    useEffect(() => {
        // get paid hitter profile
        dispatch(setPlayerId(event.data?.eventDirectors?.[0].playerId, false));
    }, []);

    useEffect(() => {
        if (event.data) {
            const { eventSchedule, registrationCancellationPolicy } = event.data;
            const timeZone = eventSchedule.timeZone?.id || 77;
            const timeZoneObj = coreUI.types.timeZones.find(tz => { return tz.id === parseInt(timeZone); });

            if (registrationCancellationPolicy?.effectiveAfterDateTimeUtc && timeZoneObj) {
                setWithdrawalFeeDate(moment.utc(registrationCancellationPolicy.effectiveAfterDateTimeUtc).tz(timeZoneObj.value).format('MMM D'));
            }
        }
    }, [event.data, coreUI.types.timeZones]);

    const isPaidHitEvent = isEventType(event.data, EventTypes.PAID_HIT);

    const bannerImageSrc = `/v1/tms/events/${bannerImage}`;

    const handlePhotoPopoverClick = (item) => {
        if (!props.previewOnly) {
            if (item.value === 'remove_banner') {
                dispatch(removeBannerPhoto(event.data?.id));
            } else if (item.value === 'upload_banner' && photoInputRef.current) {
                photoInputRef.current.click();
            }
        }
    };

    return (
        <div className="row">
            <div className="col-md-8 mt56" style={{ height: '100%' }}>
                <div className={`${!bannerImage && !isCurrentMemberAdmin ? 'd-none d-md-block' : ''}`}>
                    <div className={`position-relative ${collapsed ? 'd-none' : ''}`}>
                        <div className={`event-image`}>
                            {bannerImage && (
                                <Img
                                    src={bannerImageSrc}
                                    srcSet={`
                                                ${bannerImageSrc}?size=1x&type=banner 1x,
                                                ${bannerImageSrc}?size=2x&type=banner 2x,
                                                ${bannerImageSrc}?size=3x&type=banner 3x`}
                                />
                            )}
                            {!bannerImage && (
                                <div className="w-100 h-100" />
                            )}
                            {(isCurrentMemberAdmin) && (
                                <div className={`edit-banner`}>
                                    <PopOverMenu
                                        menuItems={[
                                            ...([{ value: 'upload_banner', label: 'Upload' }]),
                                            ...bannerImage ? ([{ value: 'remove_banner', label: 'Remove' }]) : [],
                                        ]}
                                        onSelected={handlePhotoPopoverClick}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-lg btn-dark button-float"
                                        >
                                            Edit Banner <i className="uts uts-expand mr0" />
                                        </button>
                                    </PopOverMenu>
                                    <AddPhoto
                                        maxSize={2048}
                                        uploadPhoto={props.handleUploadPhoto}
                                        uploadStart={props.handleUploadPhotoStart}
                                        text={'Upload'}
                                        // eslint-disable-next-line react/style-prop-object
                                        style={2}
                                        inputRef={photoInputRef}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {event.data?.details && (
                    <>
                        <h6 className="">
                            Description
                        </h6>
                        <Linkify openInNewTab={true}>
                            <div>
                                {countWords(event.data.details) < 200 && (<p className={`${styles.description} text-line-break`}>{event.data.details}{/* <Markdown markup={event.details} /> */}</p>)}
                                {countWords(event.data.details) >= 200 && (
                                    <div className={`${styles.description}`}>
                                        <p className="text-line-break">
                                            {overviewTabState.descriptionExpanded ? event.data.details : truncateString(event.data.details, 200)}
                                        </p>
                                        <div className={`${styles.readMore}`}>
                                            <button
                                                type="button"
                                                className={`${styles.readButton}`}
                                                onClick={() => {
                                                    overviewTabState.descriptionExpanded = !overviewTabState.descriptionExpanded;
                                                    dispatch(setOverviewTabState(overviewTabState));
                                                }}
                                            >
                                                {overviewTabState.descriptionExpanded ? (
                                                    <>
                                                        <img src={'/img/v4/icon-16px-minus-blue.svg'} alt="Read Less" /> Read Less
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={'/img/icons/addSponsorTierIcon.svg'} alt="Read More" /> Read More
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Linkify>
                    </>
                )}
                {event.data?.sponsorTiers && (
                    <div className="d-block">
                        {event.data.sponsorTiers.sort((a, b) => a.displayOrder - b.displayOrder).map((tier, i) => {
                            const filteredSponsors = tier?.sponsors?.filter((sponsor) => sponsor.imageFile !== defaultSponsorLogo).sort((a, b) => a.displayOrder - b.displayOrder);
                            return (
                                filteredSponsors?.length > 0 && (
                                <div key={tier.displayOrder}>
                                    <div className={styles.tierHeader}>
                                        <h6 className="">{tier.shortName}</h6>
                                    </div>
                                    <div className={`${styles.sponsorsContainer} ${i !== event.data.sponsorTiers.length - 1 ? styles.sponsorsContainerBottomBorder : ''}`}>
                                        {filteredSponsors.map(sponsor => {
                                            const imageUrl = `${appConfig.apiHost}/v2/tms/events/${event.data.club.id}/images/sponsorlogos/${sponsor.imageFile}`;

                                            return (
                                                <div className={`${sponsor.callToActionURL ? 'cursor-pointer' : ''} ${styles.sponsorImage}`} key={sponsor.displayOrder} onClick={() => openUrl(sponsor.callToActionURL)}><img src={imageUrl} alt={sponsor.sponsorName} /></div>);
                                        })}
                                    </div>

                                </div>
                            ));
                        })}

                    </div>
                )}
            </div>
            <div className="col-md-4">
                {isPaidHitEvent ? (
                    <>
                        <h6 className="">About</h6>
                        <div className="club-details">
                            <OrganizerCardV2
                                key={`headOrganizer}`}
                                organizer={organizerProfileData}
                                user={auth.user}
                                sendMessage={props.sendMessage}
                                className={'p0'}
                                paidHit={true}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <StatsigLink
                            gate={featureGates.CLUB_LINKS_REDIRECT}
                            enabledTo={event.data && `${appConfig.nextAppHost}/${getNewClubPath(event.data.club.tierTypeId)}/${event.data.club.id}`}
                            disabledTo={event.data && `/clubs/${event.data.club.id}`}
                        >
                            <h6 className="">{event.data?.club.name}</h6>
                        </StatsigLink>
                        {event?.data && (
                            <div className="club-details">
                                {event.data.eventDirectors?.map((director, i) => (
                                    <OrganizerCardV2
                                        key={`organizer-${i}`}
                                        organizer={director}
                                        user={auth.user}
                                        sendMessage={props.sendMessage}
                                        className={'p0'}
                                        eventTypeId={event.data.eventTypeId}
                                        providerEmail={event.data.email}
                                    />
                                ))}
                                {showContactInfo && (
                                    <>
                                        <hr className="div" />
                                        {event && (
                                            <div className="row">
                                                {event.data.phone && (
                                                    <div className="col-12 mb16">
                                                        <a href={`tel:${event.data.phone}`}><i className="uts uts-contact" /> {formatNumber({
                                                            country: event.data.phoneCountryCode,
                                                            phone: event.data.phone,
                                                        }, 'National')}
                                                        </a>
                                                    </div>
                                                )}
                                                {event.data.email && (
                                                    <div className="col-12 mb16">
                                                        <a href={`mailto:${event.data.email}`}><i className="uts uts-email" /> {event.data.email}</a>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                        {showRectangleAd && (
                            <div className="jcc d-flex mt24">
                                <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="event-profile.overview.ad.rectangle" />
                            </div>
                        )}
                        {showHealthAndSafety && (
                            <>
                                <h6 className="">Health & Safety</h6>
                                <EventHealthAndSafetyCard
                                    event={event.data}
                                />
                            </>
                        )}
                        {event.data && (
                            <>
                                <WeatherNotifications onEditWeatherNotification={onEditWeatherNotification} />
                                <Attachments />
                            </>
                        )}
                        {showCancellationPolicy && (
                            <>
                                <h6 className="">Withdrawal Policy</h6>
                                <div className="bg-white p16 fs14 fw300">
                                    {!!registrationCancellationPolicy?.withdrawalFee && (
                                        <>
                                            {withdrawalFeeDate ? (
                                                <div className="mb24">
                                                    A withdrawal fee of {currency?.symbol}{registrationCancellationPolicy?.withdrawalFee} will be charged if you withdraw from all registration divisions after {withdrawalFeeDate}.
                                                </div>
                                            ) : (
                                                <div className="mb24">
                                                    A withdrawal fee of {currency?.symbol}{registrationCancellationPolicy?.withdrawalFee} will be charged if you withdraw from all registered divisions.
                                                </div>
                                            )}
                                            {!!registrationCancellationPolicy?.description && (
                                                <div className="fw400 mb24">Additional Information</div>
                                            )}
                                        </>
                                    )}
                                    {registrationCancellationPolicy?.description}
                                </div>
                            </>
                        )}
                        {showRecurringEvents && (
                            <>
                                <h6 className="">Series Recurring Events</h6>
                                <RecurringEvents
                                    recurrentEvents={upcomingRecurringEvents?.data}
                                    timeZone={eventSchedule?.timeZone?.id || 77} // 'America/Los_Angeles'
                                />
                            </>
                        )}
                        <h6 className="">Location</h6>
                        {event?.data && (
                            <Location
                                event={event.data}
                                surface={PowerFunnelSurfaces.EVENT_GP_FIND_ACCOMMODATIONS}
                            />
                        )}
                        <h6 className="">More in this location</h6>
                        {event?.data && (
                            <SeoURL
                                event={event.data}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

OverViewTabContentV3.propTypes = {
    isCurrentMemberAdmin: PropTypes.bool,
    showEventPhoneAndEmail: PropTypes.bool,
    bannerImage: PropTypes.objectOf(any),
    collapsed: PropTypes.bool,
    previewOnly: PropTypes.bool,
    handleUploadPhoto: PropTypes.func,
    handleUploadPhotoStart: PropTypes.func,
    sendMessage: PropTypes.func,
    onEditWeatherNotification: PropTypes.func,
};
OverViewTabContentV3.defaultProps = {
    isCurrentMemberAdmin: false,
    showEventPhoneAndEmail: true,
    bannerImage: null,
    collapsed: false,
    previewOnly: false,
    handleUploadPhoto: () => { },
    handleUploadPhotoStart: () => { },
    sendMessage: () => { },
    onEditWeatherNotification: () => { },
};

export default withRouter(withAuth(OverViewTabContentV3));
